import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IssueViewModel } from '@order/viewModels/issue.viewModel';
import { PubIssuesRecordViewModel } from '@order/viewModels/pub-issues-record.viewModel';
import { DateTimeService } from '@shared/services/date-time.service';

@Component({
	selector: 'cass-multi-pub-issues-matrix',
	templateUrl: './multi-pub-issues-matrix.component.html',
	styleUrls: ['./multi-pub-issues-matrix.component.css']
})
export class MultiPubIssuesMatrixComponent {

	@Input()
	set pubsAndIssues(arg: PubIssuesRecordViewModel[]) {
		if (arg && arg.length > 0) {
			this.pubsAndIssuesVMs = arg;
			this.displayDates = this.pubsAndIssuesVMs[0].issues.map((issue: IssueViewModel) => new Date(issue.dateCode || ""));
		}
		else {
			this.pubsAndIssuesVMs = [];
			this.displayDates = [];
		}
	}

	displayDates: Date[] = [];
	public pubsAndIssuesVMs: PubIssuesRecordViewModel[] =[];

	@Output("toggleDate")
	toggleDate = new EventEmitter<{ dateString: string, pubId: string | undefined }>();

	constructor (private _dateTimeService: DateTimeService) {
	}

	singleDate_clicked(pubId: string, dateCode: string | undefined): void {
		if (dateCode) {
			this.toggleDate.emit({ dateString: dateCode, pubId: pubId });
		}
	}

	dateHeader_clicked(date: Date): void {
		const dateCode = this._dateTimeService.toBackendDate(date);
		this.toggleDate.emit({ dateString: dateCode, pubId: undefined });
	}
}
